import {
    ChangeDetectionStrategy,
    Component
} from '@angular/core';
import { FormControl, Validators, NgControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-input-dialog',
    template: `
        <div>
          <div class="modal-header">
            <h4 class="modal-title">{{message}}</h4>
          </div>
          <div class="modal-body">
              <div class="form-group">
                    <label>Title:</label>
                    <input class="form-control" [formControl]="input" type="text">
              </div>
              <div class="form-group">
                  <label>Version:</label>
                  <input class="form-control" [formControl]="version" type="text">
              </div>
              <div class="form-group">
                  <label>Uploading File:</label>
                  <input class="form-control" [formControl]="file" type="file" (change)="selectFile($event)">
              </div>
          </div>
          <div class="modal-footer">
            <button type="button"
              class="btn btn-outline-dark"
              (click)="activeModal.close()">Cancel</button>
            <button type="button"
              class="btn btn-outline-dark"
              [class.disabled]="input.invalid"
              [disabled]="input.invalid"
              (click)="activeModal.close(input.value + '|' + version.value+ '|' + selectedFiles)">Save</button>
          </div>
        </div>`,

    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadDialogComponent {
    selectedFiles: FileList;
    currentFileUpload: File;
    title: string;
    set initialValue(value: string) {
        this.input.setValue(value);
    }
    message: string;
    input = new FormControl('');
    version = new FormControl('');
    file = new FormControl('', Validators.required);

    selectFile(event) {
        this.selectedFiles = event.target.files;
        if (this.selectedFiles !== null) {
            this.currentFileUpload = this.selectedFiles.item(0);
        }
    }

    constructor(public activeModal: NgbActiveModal) {
    }
}
